module.exports = __webpack_public_path__ + "static/media/master-card.397f4206.png";